<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->

<ion-header class="app-safe-area-header bg-gray-300">
  <div class="bg-gray-300 flex items-center justify-between px-6 py-4">
    <lib-icon name="cancel" class="text-2xl text-gray-600 cursor-pointer" (click)="cancel()"></lib-icon>
    <h2 class="text-lg font-semibold text-gray-800 font-title">Filtrar sensores</h2>
    @if (form.dirty) {
    <lib-icon name="check-mark" class="text-2xl text-teal-500 cursor-pointer" (click)="confirm()"></lib-icon>
    } @else {
    <div class="w-6"></div>
    }
  </div>
</ion-header>

<ion-content>
  <div class="app-safe-area-fill bg-gray-300 px-4 py-3 flex flex-col gap-6">

    <!--@ Badges filtres actius -->
    @if (hasActiveFilters) {
    <div class="items-start gap-2 font-title">
      <div class="flex flex-wrap gap-2 mb-1">

        @for (sectorId of sectorsControl.value.slice(0, 8); track sectorId) {
          <ion-badge
            class="flex items-center gap-1 px-2.5 py-2 rounded-md font-title text-xs font-normal bg-blue-100 text-blue-700 cursor-pointer"
            (click)="removeSector(sectorId)">
            {{ getSectorLabel(sectorId) }}
            <lib-icon name="close-small"></lib-icon>
          </ion-badge>
        }

        @for (groupId of groupsControl.value.slice(0, 8 - sectorsControl.value.length); track groupId) {
          <ion-badge
            class="flex items-center gap-1 px-2.5 py-2 rounded-md font-title text-xs font-normal bg-teal-100 text-teal-700 cursor-pointer"
            (click)="removeGroup(groupId)">
            {{ getGroupLabel(groupId) }}
            <lib-icon name="close-small"></lib-icon>
          </ion-badge>
        }

        @if (form.get('hideNoGroupSensors')?.value && sectorsControl.value.length + groupsControl.value.length < 8) {
          <ion-badge
            class="flex items-center gap-1 px-2.5 py-2 rounded-md font-title text-xs font-normal bg-orange-100 text-orange-700 cursor-pointer"
            (click)="toggleNoGroupSensors()">
            Sin grupo
            <lib-icon name="close-small"></lib-icon>
          </ion-badge>
        }

        @if (form.get('hasError')?.value && sectorsControl.value.length + groupsControl.value.length + (form.get('hideNoGroupSensors')?.value ? 1 : 0) < 8) {
          <ion-badge
            class="flex items-center gap-1 px-2.5 py-2 rounded-md font-title text-xs font-normal bg-red-100 text-red-700 cursor-pointer"
            (click)="toggleHasError()">
            En error
            <lib-icon name="close-small"></lib-icon>
          </ion-badge>
        }

        @if (sectorsControl.value.length + groupsControl.value.length + (form.get('hideNoGroupSensors')?.value ? 1 : 0) + (form.get('hasError')?.value ? 1 : 0) > 8) {
          <ion-badge
            class="flex items-center gap-1 px-2.5 py-2 rounded-md font-title text-xs font-normal bg-gray-100 text-gray-700 cursor-pointer">
            +{{ sectorsControl.value.length + groupsControl.value.length + (form.get('hideNoGroupSensors')?.value ? 1 : 0) + (form.get('hasError')?.value ? 1 : 0) - 8 }}
          </ion-badge>
        }

      </div>
      <a class="text-xs underline text-gray-500 font-medium cursor-pointer" (click)="clearFilters()">
        Limpiar Filtros
      </a>
    </div>
    }

    <!--@ Card: Filtrar per -->
    <div class="bg-white rounded-2xl shadow-sm">
      <div class="py-5 px-6 border-b border-gray-200">
        <h3 class="font-medium text-gray-800 font-title">Filtrar por</h3>
      </div>
      <div class="p-6 flex flex-col gap-6">

        <div>
          <p class="text-sm font-title text-gray-700 mb-3 font-medium">Sectores</p>
          <lib-multiselect [options]="sectorOptions" placeholder="Selecciona sectores..." [formControl]="sectorsControl" title="Seleccionar sectores"
            />
        </div>

        <div>
          <p class="text-sm font-title text-gray-700 mb-3 font-medium">Grupos Visualización</p>
          <lib-multiselect [options]="groupOptions" placeholder="Selecciona grupos..." [formControl]="groupsControl" title="Seleccionar grupos"
             />
        </div>

        <div class="py-1 px-6 border-b border-gray-200">
        </div>

        <div class="flex flex-col">


          <lib-checkbox
            label="Ocultar sensores sin grupo"
            [checked]="form.get('hideNoGroupSensors')?.value"
            (checkedChange)="toggleNoGroupSensors()">
          </lib-checkbox>

        </div>
        <div class="flex flex-col">
         <lib-checkbox
            label="Mostrar sensores en error"
            [checked]="form.get('hasError')?.value"
            (checkedChange)="toggleHasError()">
          </lib-checkbox>
        </div>

      </div>
    </div>

    <!--@ Card: Ordenar per -->
    <div class="bg-white rounded-2xl shadow-sm">
      <div class="py-5 px-6 border-b border-gray-200">
        <h3 class="font-medium text-gray-800 font-title">Ordenar por</h3>
      </div>
      <div class="p-6">
        <lib-select [options]="orders" [value]="orderValue"
          (valueChange)="form.get('order')?.setValue($event); form.markAsDirty()" className="w-full">
        </lib-select>
      </div>
    </div>

  </div>
</ion-content>

@if (form.dirty) {
<ion-footer class="ion-no-border app-safe-area-footer">
  <div class="bg-gray-300 px-6 py-6 flex gap-4 justify-center">
    <lib-button class="min-w-[134px]" variant="outline"
      className="bg-white border-gray-200 text-gray-700 h-12 font-title font-medium" (btnClick)="cancel()">
      Cancelar
    </lib-button>
    <lib-button class="min-w-[134px]" variant="primary"
      className="bg-teal-400 border-teal-400 hover:bg-teal-500 h-12 font-title font-medium" (btnClick)="confirm()">
      Aceptar
    </lib-button>
  </div>
</ion-footer>
}
